export const mapSortingKey = {
  descend: "DESC",
  ascend: "ASC",
};
